export const ROOT_URL = '/scanline/';

export const SUPPORT_EMAIL = 'aip@corrpro.com';
